import * as actionTypes from '../../../actions/actionTypes';
import { updateObject } from '../../../utility.js';

const initialState = {
    jobs: [],
    loading: false,
    error: false,
    searched: false
};

const calculatorJobsFetchStart = ( state, action ) => {
    return updateObject( state, { loading: true, error: false, searched: action.searched } );
};

const calculatorJobsFetchSuccess = ( state, action ) => {
    return updateObject( state, {
	    jobs: action.jobs,
        loading: false,
        error: false
    } );
};

const calculatorJobsFetchFail = ( state, action ) => {
    return updateObject( state, { loading: false, error: action.error } );
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
    	case actionTypes.CALCULATOR_JOBS_FETCH_START: return calculatorJobsFetchStart( state, action );
    	case actionTypes.CALCULATOR_JOBS_FETCH_SUCCESS: return calculatorJobsFetchSuccess( state, action );
    	case actionTypes.CALCULATOR_JOBS_FETCH_FAIL: return calculatorJobsFetchFail( state, action );
        default: return state;
    }
};


export default reducer;


// WEBPACK FOOTER //
// ./src/_store/reducers/calculator/jobs/jobs.js